import { render, staticRenderFns } from "./OrderInterval.vue?vue&type=template&id=60fc9cd6&scoped=true&"
import script from "./OrderInterval.vue?vue&type=script&lang=js&"
export * from "./OrderInterval.vue?vue&type=script&lang=js&"
import style0 from "./OrderInterval.vue?vue&type=style&index=0&id=60fc9cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fc9cd6",
  null
  
)

export default component.exports